import { createFileRoute, redirect } from "@tanstack/react-router";
import { SysGetLoginDefaultRoute } from "@tubo/api-models/hooks/system-config-api.hooks";
import {
  getLoginNavigationOptions,
  resolveLoginDefaultRoute,
} from "@client/lib/login-default-route";

export const Route = createFileRoute("/_app/")({
  beforeLoad: async () => {
    const data = await SysGetLoginDefaultRoute().catch(() => null);
    throw redirect(
      getLoginNavigationOptions(resolveLoginDefaultRoute(data?.value)),
    );
  },
});
